export const formatDate = (uploadDate) => {
  const now = new Date();
  const upload = new Date(uploadDate);
  const diffMs = now - upload;
  const diffMins = Math.floor(diffMs / 60000);
  const diffHours = Math.floor(diffMins / 60);
  const diffDays = Math.floor(diffHours / 24);

  if (diffMins < 51) return `${diffMins} minutes ago`;
  if (diffMins < 60) return `about 1 hour ago`;
  if (diffHours < 24) return `${diffHours} hours ago`;
  if (diffDays < 29) return `${diffDays} days ago`;
  if (diffDays < 36) return `about a month ago`;
  return `${upload.toLocaleString("default", {
    month: "long",
  })} ${upload.getDate()}, ${upload.getFullYear()}`;
};

export const getDifferenceInSeconds = (date1, date2) => {
  const dateObj1 = new Date(date1);
  const dateObj2 = new Date(date2);

  const differenceInMilliseconds = Math.abs(dateObj2 - dateObj1);
  const differenceInSeconds = Math.floor(differenceInMilliseconds / 1000);

  return differenceInSeconds;
};
